import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';
import { PlannerMapDataElement } from 'components/common/types/Planner.types';

export const areMapDataArraysEqual = (
  arr1: PlannerMapDataElement[] = [],
  arr2: PlannerMapDataElement[] = [],
): boolean => {
  const mapOnlyEssentials = (asset: PlannerMapDataElement): Partial<PlannerMapDataElement> =>
    pick(asset, ['name', 'geometry', 'isVisible', 'index']);

  return Boolean(arr1.length && arr2.length) && isEqual(arr1.map(mapOnlyEssentials), arr2.map(mapOnlyEssentials));
};
